<!--<c-footer>-->
  <div class="default-footer-wrapper w-100 d-flex justify-content-between">
    <div class="d-inline-flex ps-3">
      Version: {{version}}
    </div>
    <div class="ms-auto d-inline-flex pe-3">
      <span>Techpromux</span>
      <span>&copy;&nbsp;{{currentDate | date :'yyyy' }}</span>
    </div>
  </div>
<!--</c-footer>-->
